export default  {
    CHAIN_ID:1,
    CONTRACT_ADDRESS:"0xae31F5C766A526f5679915F2dB1aB22DAf09820a",
    RPC:"https://speedy-nodes-nyc.moralis.io/cf8b736636d60bdd2970f22a/eth/mainnet",

}